// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.9511 21.7H0.0488281L12 1L23.9511 21.7ZM11 15H13V9.5H11V15ZM13.0039 16.5H11V18.5039H13.0039V16.5Z"}}]};

const ErrorTriangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'error-triangle-filled',
    ref,
    icon: element,
  },
));

ErrorTriangleFilledIcon.displayName = 'ErrorTriangleFilledIcon';

export default ErrorTriangleFilledIcon;
